import React from 'react';
import { withRouter } from 'react-router-dom';

//HELPERS
import * as c from '../../helpers/constants'
import { getToken } from '../../store/auth';

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { mailingAction } from '../../store/anexos';

//COMPONENTS
import { Row, Column, IBox, Title, Content, Button, Select } from '../inspinia';
import CircularProgress from '@material-ui/core/CircularProgress';

class AnexosUpload extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state =
        {
            loading: false,
            form: this.formInitialState(),
            idMailing: 0,
            idEmpresa: 0,
            mensagem: {
                titulo: "",
                mensagem: "",
                html: ""
            },
            disabled: false

        }

        this.handleSave = this.handleSave.bind(this);
        this.onChangeFile = this.onChangeFile.bind(this);
        this.getMessage = this.getMessage.bind(this);
        this.clearForm = this.clearForm.bind(this);
    }

    formInitialState() {
        return {
            file: "",
        }
    }

    clearForm() {
        document.getElementsByClassName('custom-file-label').item(0).textContent = "Selecione o arquivo";
        const file = document.querySelector('.file');
        file.value = '';
        this.state.form.file = '';
    }

    onChangeFile(e) {

        const form = this.state.form;
        form.file = e.target.files[0];

        this.setState({ file: e.target.files[0] });

        if (form.file != null && form.file != "") {
            const fileType = form.file.name.split(".")[1];
            if(fileType == "zip" || fileType == "7z"){
                if(form.file.size > 110100480) {
                    this.clearForm();
                    throw (c.TOASTER_ERROR("Tamanho do arquivo não permitido."));
                }
                document.getElementsByClassName('custom-file-label').item(0).textContent = form.file.name;
            } else {
                this.clearForm();
                throw (c.TOASTER_ERROR("Formato do arquivo não permitido."));
            }
        } else {
            document.getElementsByClassName('custom-file-label').item(0).textContent = "Selecione o arquivo";
        }
    }

    handleSave(e) {
        const self = this;
        const state = self.state;

        e.preventDefault(); if (state.loading) return;
        self.setState({ ...state, loading: true, mensagem: { titulo: "", mensagem: "" } });

        if (this.state.form.file === '') {
            c.TOASTER_ERROR('Favor incluir arquivo.');
            self.setState({ ...state, loading: false });
            return;
        }

        // dados vindos da sessão
        this.state.idEmpresa = this.props.mailing.mailing.mailing;

        if (this.state.idEmpresa === '' || this.state.idEmpresa == 0 || this.state.idEmpresa == undefined) {
            c.TOASTER_ERROR('Empresa não informada.');
            self.setState({ ...state, loading: false });
            return;
        }

        // dados vindos da sessão
        this.state.idMailing = this.props.mailing.mailing.mailing;

        if (this.state.idMailing === '' || this.state.idMailing == 0 || this.state.idMailing == undefined) {
            c.TOASTER_ERROR('Mailing não informada.');
            self.setState({ ...state, loading: false });
            return;
        }

        let data = new FormData();
        data.append('empresa', this.state.idEmpresa);
        data.append('mailing', this.state.idMailing);
        data.append('file', state.file);

        // URL da integração
        let url = `${c.API_BASE_URL}/save-anexos`;

        const _token = c.AUTH_HEADER(getToken());
        const options = {
            method: 'POST',
            body: data,
            headers: { 'Authorization': _token}
        };

        fetch(url, options).then(async (response) => {
            
            response.json().then(resp => {
            let isError = false;
            let titulo = "";
            let message = "";
    
            if (resp.status === 200) {
                message = resp.message;
            } else {
                isError = true;
                message = resp.message;
                c.TOASTER_ERROR(resp.message);
            }


            if (isError) {
                titulo = "Mensagens de erro:";
                this.clearForm();
            } else {
                titulo = "Upload Iniciado - Gentileza acompanhar na funcionalidade \"Upload Anexos\"";
                this.clearForm();
            }

            message = resp.message === "true" ? "" : resp.message;

            self.setState({
                ...state,
                loading: false,
                form: {
                    file: "",
                },
                idMailing: 0,
                idEmpresa: 0,
                mensagem: {
                    ...state.mensagem,
                    titulo: titulo,
                    mensagem: message,
                    html: ""
                },
                disabled: false
            });
        });
    });
}

    getMessage() {
        if (this.state.mensagem.titulo != "") {
            return (
                <>
                    <Row className="mt-5 ml-5px " style={{ justifyContent: "center", }}>
                        <strong>{this.state.mensagem.titulo}</strong>
                    </Row>
                    <Row className="ml-5px " style={{ justifyContent: "center" }}>
                        {this.state.mensagem.mensagem}
                    </Row>
                    <Row className="ml-5px " style={{ justifyContent: "center" }}>
                        {this.state.mensagem.html}
                    </Row>
                </>
            );
        }
    }

    render() {
        const form = this.state.form;
        let isDisabled = this.state.loading || this.state.disabled;

        return (
            <div>
                {/* MAIN CONTENT */}
                <Row>
                    <Column>
                        <IBox>
                            <Title className="pt-5 text-center">
                                <h2 className="fs-20 fw-600 text-body">Envio de Anexos</h2>
                                <p className="fs-14 fw-400 text-body">Tipos de Arquivos Permitidos: <strong>zip</strong> e <strong>7z</strong>.</p>
                                <br/>
                                <p style={{marginBottom: 0}} className="fs-14 fw-400 text-body">Tamanho <strong>MÁXIMO</strong> permitido do arquivo: <i>100 MB <strong>ZIP</strong></i> e <i>100 MB <strong>7z</strong></i></p>                     
                                <p className="fs-14 fw-400 text-body">Os anexos deverão estar no formato <i>.pdf</i></p>                 
                            </Title>

                            <Content classNaFfe="p-3 border-0">
                                {/* FORMULÁRIO */}
                                <form>
                                    <Row className="m-0 mb-5">
                                        <Column size="9" className="container mx-auto p-0">
                                            <Row className="ml-5px " style={{ justifyContent: "left" }}>
                                                <Column size="11" className="px-1">
                                                    <input disabled={isDisabled} type="file" name="file" className="custom-file-input file" id="validatedCustomFile" required onChange={this.onChangeFile} />
                                                    <label className="custom-file-label" for="validatedCustomFile">Selecione o arquivo</label>
                                                </Column>
                                            </Row>
                                        </Column>
                                    </Row>

                                    {/* NAVEGAÇÃO */}
                                    <Row className="m-0 mb-3">
                                        <Column size="auto" className="mx-auto">
                                            <div className="input-group">

                                                <Button onClick={this.handleSave} disabled={isDisabled} className="mx-1" width="130px">Salvar</Button>

                                                <div className="ml-4">
                                                    {this.state.loading && (
                                                        <CircularProgress
                                                            size={30}
                                                            thickness={4}
                                                            color='inherit'
                                                            variant='indeterminate' />
                                                    )}
                                                </div>
                                            </div>
                                        </Column>
                                    </Row>
                                    {this.getMessage()}
                                </form>
                            </Content>
                        </IBox>
                    </Column>
                </Row>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { auth: state.auth, mailing: state.mailing };
}

function mapDispatchToProps(dispatch)
{
    return {actions: { mailing: bindActionCreators(mailingAction, dispatch) }};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AnexosUpload));
